import { Injectable } from '@angular/core';
import { Constants } from 'app/constants';
import { StateService } from '@uirouter/core';

@Injectable({
    providedIn: 'root'
})
export class ContainerClassService {
    constructor(private stateService: StateService) {}

    // Determines the layout class based on the current state.
    public get(): string {
        if (this.isInAnyState(Constants.LAYOUT_STATES.maxXL)) {
            return 'container-max-xl';
        }

        if (this.isInAnyState(Constants.LAYOUT_STATES.base)) {
            return 'base';
        }

        if (this.isInAnyState(Constants.LAYOUT_STATES.entry)) {
            return 'entry-layout';
        }

        if (this.isInAnyState(Constants.LAYOUT_STATES.grid)) {
            return 'grid-layout';
        }

        // Default
        return 'container-xxl';
    }

    // Checks if the current state is in any of the provided states.
    private isInAnyState<T extends readonly string[]>(states: T): boolean {
        return states.some((state) => this.stateService.includes(state));
    }
}
